var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isSupAdmin)?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('Card-Etat-Dette')],1),_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('liste-Decodeur'),_c('Card-Etat-Ticket')],1),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('Card-Total-Decodeur'),_c('Card-Pub')],1),_c('v-col',{attrs:{"cols":"12","md":"8"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }